import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper'; // We forgot to publish this flag in the first pass
//
// Fun fact: Belgium often lacks a government
// https://en.wikipedia.org/wiki/2019%E2%80%9320_Belgian_government_formation

var FlagBE = function FlagBE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "belgium"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M0,90 C0,129.186565 25.0442286,162.523736 59.9999996,174.878829 L60,5.12116759 C25.0442286,17.4762637 0,50.8134354 0,90 Z",
    id: "black",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M180,90 C180,50.8134354 154.955771,17.4762637 120,5.12117139 L120,174.878832 C154.955771,162.523736 180,129.186565 180,90 Z",
    id: "red",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M60,5.12051622 L60,174.879484 C69.3825591,178.19561 79.479186,180 89.9972382,180 C100.517354,180 110.61588,178.194901 120,174.877528 L120,5.12246865 C110.61588,1.80509864 100.517354,0 89.9972382,0 C79.479186,0 69.3825591,1.80439039 59.9999996,5.12052001 L60,5.12051622 L60,5.12051622 Z",
    id: "yellow",
    fill: "#F2C500"
  })));
};

FlagBE.displayName = 'FlagBE';
export default withFlagWrapper(FlagBE);
//# sourceMappingURL=index.js.map